import { useEffect } from "react";
import { supabase } from "../supabaseClient";
import useIntersectionObserver from "./useIntersectionObserver";
import useCountUp from "./useCountUp";
import useStatsFetcher from "./useStatsFetcher";

export default function usePlatformAchievement() {
  const stats = useStatsFetcher();
  const { ref: sectionRef, isIntersecting } = useIntersectionObserver(0.5);
  const counts = useCountUp(
    stats.map((stat) => stat.value),
    isIntersecting,
    2000,
    10
  );

  // اختبار الاتصال بـ Supabase
  useEffect(() => {
    const testConnection = async () => {
      const { data, error } = await supabase
        .from("volunteering_tasks")
        .select("*")
        .limit(1);
      console.log("Test connection:", { data, error });
    };
    testConnection();
  }, []);

  return { sectionRef, stats, counts };
}
